export const booleanAttr = (
  value: boolean | undefined,
): 'true' | 'false' | undefined => {
  return value != null
    ? value.toString() === 'true'
      ? 'true'
      : 'false'
    : undefined;
};
